import React from 'react';
import { HOCs } from '@pearsontechnology/aero-components';

import AddKnowledgeMapButton from './AddKnowledgeMapButton';
import AddKnowledgeMapMenu from './AddKnowledgeMapMenu';

const { enhanceWithPopper } = HOCs;
const ButtonWithPopper = enhanceWithPopper(AddKnowledgeMapButton);

const AddKnowledgeMap = (props) => (
  <ButtonWithPopper placement="bottom-end" hidepopperonclick>
    <AddKnowledgeMapMenu {...props} />
  </ButtonWithPopper>
);

export default AddKnowledgeMap;
